<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>修改设备</BreadcrumbItem>
        </Breadcrumb>
        <div class="dev_data">
          <div><span style="color: red;">*</span>设备编号<Input v-model="devForm.deviceNo" style="width: 300px" :maxlength=32 disabled/></div>
          <div><span style="color: red;">*</span>合作伙伴<Input v-model="devForm.manufacturer" disabled style="width: 300px" :maxlength=32 /></div>
          <div><span style="color: red;">*</span>设备类型<Input v-model="devForm.deviceType" disabled style="width: 300px" :maxlength=32 /></div>
          <div><span style="color: red;">*</span>设备场景
            <Select v-model="devForm.scene" style="width:300px;text-align: left">
              <Option v-for="item in sceneList" :value="item.key" :key="item.key">{{ item.label }}</Option>
            </Select>
          </div>
          <div><span style="color: red;">*</span>设备用途
            <Select v-model="devForm.devicePurpose" style="width:300px;text-align: left">
              <Option v-for="item in devicePurposeList" :value="item.key" :key="item.key">{{ item.label }}</Option>
            </Select>
          </div>
          <div><span style="color: red;"></span>维保时间<DatePicker v-model="devForm.maintenanceTime" type="date" placeholder="Select date" style="width: 300px"></DatePicker></div>
          <div class="btn">
            <Button type="primary" style="width: 120px;" @click="submit">确定</Button>
            <Button style="width: 120px;" @click="goBackPage">取消</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api/index'
import TopOpe from '../top-ope/top-ope'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess, nError} from '../../util/notice'

export default {
  components: {TopOpe},
  name: 'modify-device',
  data () {
    return {
      sceneList: [{
        key: '1',
        label: '校园设备'
      }, {
        key: '2',
        label: '安徽电力设备'
      }, {
        key: '3',
        label: '社区设备'
      }, {
        key: '4',
        label: '渠道设备'
      }, {
        key: '5',
        label: '园区设备'
      }],
      devicePurposeList: [
        {
          key: '1',
          label: '门禁'
        }, {
          key: '2',
          label: '停车'
        }
      ],
      devForm: {
        deviceNo: '',
        manufacturer: '',
        deviceType: '',
        scene: '',
        devicePurpose: ''
      }
    }
  },
  created () {
    let searchId = this.$route.params.id
    this.getConfig(searchId)
  },
  methods: {
    goBackPage () {
      this.$router.push({
        path: '/upgrade_management'
      })
    },
    getConfig (id) {
      this.$axios.get(`${httpUrl.url}/manage/device/getById/${id}`)
        .then(res => {
          if (res.data.retCode === 1) {
            this.devForm = res.data.data
          }
        })
        .catch(errorHandler('查询失败'))
    },
    submit () {
      // if (!this.devForm.deviceNo) {
      //   nError('设备编号不能为空')
      //   return false
      // }
      // if (!this.devForm.manufacturer) {
      //   nError('合作伙伴不能为空')
      //   return false
      // }
      // if (!this.devForm.deviceType) {
      //   nError('设备类型不能为空')
      //   return false
      // }
      // if (!this.devForm.maintenanceTime) {
      //   nError('维保时间不能为空')
      //   return false
      // }
      this.$axios.post(`${httpUrl.url}/manage/device/update`, this.devForm)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.$router.push({
              path: '/upgrade_management'
            })
          }
        })
        .catch(
          errorHandler('修改失败')
        )
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    width: 100%;
    height: 100%;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .dev_data {
    margin-top: 80px;
  }

  .dev_data div {
    margin: 10px;
    text-align: center;
  }

  .btn button {
    margin: 30px 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/upgrade-management/modify-device.vue